const configureImageArr = (arr: any) => {
  if (arr && arr[0]) {
    return arr.map(x => ({ big: x.img, medium: x.img, small: x.img }));
  } else {
    return [];
  }
};

export { configureImageArr };



// WEBPACK FOOTER //
// ./src/app/media/photo-gallery/utils.ts